<template>
    <div class="depart_manage" :style="screenHeight">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="left_tree">
        <ul id="deptmenuTree" class="ztree" style="width:100%;overflow:auto;"></ul>
      </div>
      <div style="padding-left: 10px;" class="fixed_table">
        <div class="fixed_operation_btn">
          <Button type="info" @click="addmenu" v-if="roleList['3_12-3-1']">添加导航</Button>
          <Button type="primary" @click="addsubmenu" v-if="roleList['3_12-3-5']">添加子导航</Button>
        </div>
        <div class="table_head">
          <table>
            <tr>
              <th class="font_style_set" style="width:5%;"><Checkbox v-model="checkedAll"  @on-change="checkedAllList()"></Checkbox></th>
              <th class="font_style_set" style="width:30%;">导航名称</th>
              <th class="font_style_set" style="width:50%;">导航说明</th>
               <th class="font_style_set" style="width:15%;border-right: 0px">操作</th>
            </tr>
          </table>
        </div>
        <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="footer_style" :style="tableHeight">
          <table class="table_head_footer">
            <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
              <td  style="width:5%;"><CheckboxGroup v-model="singleCheckedList"><Checkbox :label="item.id"></Checkbox></CheckboxGroup></td>
              <td  style="width:30%;">{{item.navName}}</td>
              <td  style="width:50%;">{{item.descr}}</td>
              <td class="template_table_btn" style="width:15%;">
                <span class="search_btn" @click="editDept(item.id)" v-if="roleList['3_12-3-2']">编辑</span>
                <span class="search_btn" @click="deleteDept(item.id)" v-if="roleList['3_12-3-3']">删除</span>
                <!-- <span class="search_btn" @click="distribute(item.id)" v-if="roleList['3_12-3-4']">分配</span> -->
              </td>
            </tr>
          </table>
        </div>
        <div class="page_style">
          <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
          <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
        </div>
      </div>
      <AddsubmenuPop :showAddsubmenu="showAddsubmenu" @closeSubmenu="closeSubmenu" :deptId="deptId" :pid="pid" :title="title" :higherLevelDeptList="inspectTreeData" :journalType="journalType" :menuId="menuId"></AddsubmenuPop>
      <menudistributePop @closeDistribute="closeDistribute" :showDistribute="showDistribute" :skillId="skillId" :deptId="deptId" :pid="pid" :title="title" :higherLevelDeptList="inspectTreeData"></menudistributePop>
    </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import AddsubmenuPop from '@/components/systemSetup/DialogueConfigure/AddsubmenuPop.vue'
    import menudistributePop from '@/components/systemSetup/DialogueConfigure/menudistributePop.vue'
    export default {
        name: "NavigationMenu",
        mixins:[publicFunClass],
        components:{
          AddsubmenuPop,
          menudistributePop
        },
        props:{
          pageCode:String
        },
        data(){
          return{
            showPageCount:0,
            roleList:JSON.parse(localStorage.getItem("roleList")),
            total:0,
            pageSizeList:[10,20,30,40,50,100,200],
            pageSize:20,
            currentPage:1,
            speedChangePage: 1,
            spinShow:false,
            showAddsubmenu:false,
            deptId:'',
            pid:'',
            title:'',
            checkedAll:false,
            singleCheckedList:[],
            infoTableList:[],
            screenHeight:{height:''},
            tableHeight:{height:''},
            inspectTreeData:[],
            journalType:'',
            menuId:'',
            selectedTreeId:'',
            showDistribute:false,
            skillId:'',
            selectedTreeSubId:'',
          }
        },
        methods:{

          //设备树初始化
          initDepartTree:function () {
            let that=this;
            let setting = {
              view: {
                dblClickExpand: false,
                showLine: true,
                selectedMulti: false
              },
              data: {
                simpleData: {
                  enable:true,
                  idKey: "id",
                  pIdKey: "pid",
                  rootPId: ""
                },
                key:{
                  name:"navName"
                }
              },
              callback: {
                onClick: zTreeOnClick
              }
            };
            function zTreeOnClick(event,treeId,treeNode) {
              that.selectedTreeId=treeNode.id;
              //that.searchChildrenDept(treeNode.id);
              that.selectedTreeSubId=treeNode.subId;
              that.searchChildrenDept(that.selectedTreeSubId);
            }
            let zNodes =this.inspectTreeData;
            if (zNodes){
              $(document).ready(function(){
                let zTree=$.fn.zTree.init($("#deptmenuTree"), setting, zNodes);//t:用于展现 zTree 的 DOM 容器,setting:zTree 的配置数据,zNodes:zTree 的节点数据
                let nodes = zTree.getNodes();
                if (nodes.length > 0) {
                  zTree.selectNode(nodes[0]);//默认选中根节点
                }
                zTree.expandAll(true);

              });
            }
          },
          initSearch:function () {
            let param={
              journalType:"系统管理=>会话配置=>导航菜单=>查询",
              menuId:"3_12-3",
            };
            let that=this;
            this.$http.post("chatNav/toIndex.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              let list=res.data.obj.tree;
              if(list==""){
                that.infoTableList =[];
              }
              that.inspectTreeData =list;
              that.initDepartTree();
              that.searchChildrenDept(list[0].subId);

              // for (let i=0;i<list.length;i++){
              //   let pid=list[i].pid;
              //   if(pid=="0"){
              //     that.selectedTreeId=list[i].id;
              //     that.searchChildrenDept(list[i].subId);
              //   }
              // }

            });
          },
          searchChildrenDept:function (ids) {
            let param={
              ids:ids,
              pageNum:this.currentPage,
              pageSize:this.pageSize,
              journalType:"null",
              menuId:"null"
            };
            let that=this;
            this.$http.post("chatNav/selectLevel.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.singleCheckedList=[];
              that.total=res.data.obj.list.totalSize;
              //that.infoTableList =res.data.obj.deptList.content;
              that.infoTableList =res.data.obj.list.content;
            });
          },


          closeSubmenu:function(flag){
            this.showAddsubmenu=false;
            let that=this;
            if(flag){
                  that.initSearch();
            }
          },
          addmenu:function(){//添加导航
            this.title="添加导航";
            this.showAddsubmenu=true;
            this.deptId="";
            this.pid="0";
            this.menuId="3_12-3-1";
            this.journalType="系统管理=>会话配置=>导航菜单=>添加"
          },
          addsubmenu:function(){//添加子导航
            this.title="添加子导航";
            this.showAddsubmenu=true;
            this.deptId="";
            this.pid=this.selectedTreeId;
            this.menuId="3_12-3-5";
            this.journalType="系统管理=>会话配置=>导航菜单=>添加"
          },
          editDept:function(id){
            this.showDistribute=true;
            this.deptId=id;
            this.skillId=id;
            this.pid="";
            this.title="编辑导航";
            this.menuId="3_12-3-2";
            this.journalType="系统管理=>会话配置=>导航菜单=>编辑"
          },
          //分配
          closeDistribute:function(flag){
              this.showDistribute=false;
              let that=this;
              if(flag){
                      that.initSearch();
              }
          },
          deleteDept:function(id){
            let param={
              journalType:"系统管理=>会话配置=>导航菜单=>删除",
              menuId:"3_12-3-3",
              id:id
            };
            let that=this;
            this.$Modal.confirm({
              title: '提示',
              content: "是否确定删除",
              onOk: () => {
                that.spinShow = true;
                that.$http.post("chatNav/doDelete.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.spinShow = false;
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                  setTimeout(function () {
                    that.spinShow = false;
                    that.$Message.success("删除成功");
                     that.initSearch();
                  }, 1500);

                });
              }
            });
          },
          //翻页时执行的
           initUpSearch:function () {
             if(!this.selectedTreeSubId && this.inspectTreeData && this.inspectTreeData.length > 0){
               this.selectedTreeSubId = this.inspectTreeData[0].subId;
             }
             this.searchChildrenDept(this.selectedTreeSubId);
          },

          //设备信息当前页改变
          changeCurrent(event) {
            this.currentPage=event;
            this.initUpSearch();
          },
          //设备信息页面显示数量改变
          changeSize(event) {
            this.currentPage=1;
            this.pageSize=event;
            this.initUpSearch();
          },

          // distribute:function (id) {
          //     this.showDistribute=true;
          //     this.skillId=id;
          // }

        },
        created(){
          this.screenHeight.height=this.mountHeight(91);
          this.tableHeight.height=this.mountHeight(201);
          this.initSearch();
        },
        watch:{
          currentPage:function () {
            this.speedChangePage= this.currentPage;
          },
          total:function () {
            if(this.total<=this.pageSize){
              this.speedChangePage=1;
              this.currentPage=1;
            }
          },
          pageCode:function () {
            // if(this.pageCode=='3_12-3' && this.showPageCount==0){
            //   this.showPageCount++;
            //   this.initSearch();
            // }
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/NavigationMenu.vue